import React from 'react';
import { Book, FileText, Code, Video, MessageSquare } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
export function Resources() {
  const resources = [{
    category: 'Documentation',
    icon: <Book className="h-6 w-6 text-cyan-400" data-id="element-321" />,
    items: ['Getting Started Guide', 'Installation & Setup', 'Configuration Reference', 'Dashboard Management']
  }, {
    category: 'API Reference',
    icon: <Code className="h-6 w-6 text-cyan-400" data-id="element-322" />,
    items: ['REST API Overview', 'Authentication', 'Endpoints & Methods', 'SDKs & Libraries']
  }, {
    category: 'Case Studies',
    icon: <FileText className="h-6 w-6 text-cyan-400" data-id="element-323" />,
    items: ['FinTech: Reducing Latency by 40%', 'SaaS: Scaling to 10M Users', 'Healthcare: Securing Patient Data', 'E-commerce: Black Friday Readiness']
  }, {
    category: 'Video Tutorials',
    icon: <Video className="h-6 w-6 text-cyan-400" data-id="element-324" />,
    items: ['Platform Walkthrough', 'Setting up Alerts', 'Custom Report Building', 'Threat Analysis Workflow']
  }];
  return <div className="min-h-screen bg-slate-950" data-id="element-325">
      <section className="py-20 border-b border-slate-800" data-id="element-326">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-327">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-328">
            Resources & Support
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-329">
            Everything you need to get the most out of the njgod platform.
          </p>
        </div>
      </section>

      <section className="py-24" data-id="element-330">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-331">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-332">
            {resources.map((section, idx) => <Card key={idx} className="bg-slate-900/50 border-slate-800" data-id="element-333">
                <div className="flex items-center mb-6" data-id="element-334">
                  <div className="p-2 bg-slate-800 rounded-lg mr-4" data-id="element-335">
                    {section.icon}
                  </div>
                  <h2 className="text-2xl font-bold text-white" data-id="element-336">
                    {section.category}
                  </h2>
                </div>
                <ul className="space-y-4" data-id="element-337">
                  {section.items.map((item, i) => <li key={i} data-id="element-338">
                      <a href="#" className="text-slate-400 hover:text-cyan-400 transition-colors flex items-center group" data-id="element-339">
                        <span className="h-1.5 w-1.5 rounded-full bg-slate-600 group-hover:bg-cyan-400 mr-3 transition-colors" data-id="element-340"></span>
                        {item}
                      </a>
                    </li>)}
                </ul>
                <div className="mt-6 pt-6 border-t border-slate-800" data-id="element-341">
                  <Button variant="ghost" className="text-cyan-400 hover:text-cyan-300 p-0" data-id="element-342">
                    View all {section.category} &rarr;
                  </Button>
                </div>
              </Card>)}
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-900/30 border-t border-slate-800" data-id="element-343">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-344">
          <MessageSquare className="h-12 w-12 text-cyan-500 mx-auto mb-6" data-id="element-345" />
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-346">
            Still need help?
          </h2>
          <p className="text-slate-400 mb-8" data-id="element-347">
            Our support team is available 24/7 to assist with any technical
            issues or questions.
          </p>
          <div className="flex justify-center gap-4" data-id="element-348">
            <Button data-id="element-349">Contact Support</Button>
            <Button variant="outline" data-id="element-350">Join Community Forum</Button>
          </div>
        </div>
      </section>
    </div>;
}